import type storeZh from '../zh/store';

const store: typeof storeZh = {
  title: 'Store authorization',
  market: 'Market',
  store_type: 'Store type',
  all: 'All',
  market_vn: 'Vietnam',
  market_th: 'Thailand',
  market_id: 'Indonesia',
  market_my: 'Malaysia',
  market_ph: 'Philippines',
  market_sg: 'Singapore',
  type_cross: 'Cross-border stores',
  type_local: 'Local stores',
  shop_local: 'Local',
  shop_cross: 'Cross-border',
  authorized: 'Authorized',
  store_code: 'Store code',
  seller_email: 'Seller email',
  authorized_at: 'Authorized at',
  can_send: 'Can send ',
  channel_dm: 'DMs',
  can_send_mid: ', ',
  channel_email: 'emails',
  can_send_end: ', and start ',
  targeted_invite: 'targeted invitations',
  unbind: 'Unlink',
  unbind_title: 'Confirm store unlink',
  unbind_confirm: 'Confirm unlink',
  unbind_desc:
    'This frees 1 slot and revokes the token. DMs for this store will pause, and targeted invitations in progress will stop syncing.',
  empty_slot: 'Empty slot',
  sea_only: 'Only Southeast Asia markets can be authorized',
  authorize_new: 'Authorize a new store',
  purchase_slot: 'Buy slot',
  authorize_title: 'Authorize TikTok store',
  go_authorize: 'Authorize now',
  authorize_desc:
    'You will be redirected to the official TikTok authorization page. A successful link uses 1 empty slot. Store passwords are not stored.',
  auth_market: 'Authorization market',
  auth_market_placeholder: 'Select a Southeast Asia market',
  auth_market_hint: 'Only Southeast Asia stores can be authorized right now',
  authorize_redirect: 'Redirecting to {{market}} store authorization',
  authorize_failed: 'Failed to get the authorization link',
  unbind_success: 'Unlinked: {{name}}',
  unbind_failed: 'Could not unlink the store',
  add_auth: 'Add authorization',
  safety_hint: 'Passwords are not stored · Unlink frees the slot',
  load_failed: 'Could not load the store list'
};

export default store;
